import 'flatpickr';
import * as frFlatpickr from 'flatpickr/dist/l10n/fr'

import { getQueryStringParameter } from './helpers';

// TODO: This is apparently not used anywhere? If so, delete this plugin (and its CSS)
const fr = frFlatpickr.default.fr;

const initFlatpickr = (element) => {
  if (!(element instanceof Element) && element.getAttribute('type') !== 'date') {
    throw 'initFlatpickr must be called with an input of type date';
  }

  let options = {};

  const locale = getQueryStringParameter('locale');

  options['dateFormat'] = 'Y-m-d';
  options['altInput'] = true;

  if (locale === 'en') {
    options['altFormat'] = 'm/d/Y';
  } else {
    options['altFormat'] = 'd/m/Y';
    options['locale'] = fr;
  }

  options['onReady'] = (_selectedDates, _dateStr, instance) => {
    instance.setDate(instance.parseDate(instance.input.getAttribute('value'), 'Y-m-d'));
  };

  if (element instanceof Element) {
    if (element.hasAttribute('max')) {
      options['maxDate'] = flatpickr.parseDate(element.getAttribute('max'), 'Y-m-d');
    }

    if (element.hasAttribute('min')) {
      options['minDate'] = flatpickr.parseDate(element.getAttribute('min'), 'Y-m-d');
    }
  }

  const fp = flatpickr(element, options);

  return fp;
};

$(() => {
  $('input[type=date].custom-datepicker').each((_, inputElement) => {
    initFlatpickr(inputElement);
  });
});
